import axios from "axios";

const baseURL = 'http://localhost:3000';

function sleep(ms = 2000): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, ms));
}
export const initializeAxiosConfig = () => {
  const client = axios.create({
    baseURL,
  });
  client.interceptors.response.use(async (response) => {
    // add artificial delay for dev env
    if (process.env.NODE_ENV === 'development') {
      await sleep();
    }
    return response.data;
  });
}


